// extracted by mini-css-extract-plugin
export default {"goldStyle":"goldStyle___YMxvl","borderStyle":"borderStyle___nXqSr","greenStyle":"greenStyle___XkpAc","greenIconStyle":"greenIconStyle___ii4Oo"};